import i18n from 'i18nextInstance';

export const HEADERS = [{
    key: 'date',
    label: i18n.t('Fecha')
}, {
    key: 'time',
    label: i18n.t('Hora')
}, {
    key: 'action',
    label: i18n.t('Acción')
}, {
    flex: 2,
    key: 'user',
    label: i18n.t('Usuario')
}, {
    flex: 3,
    key: 'additional',
    label: i18n.t('Información')
}];
